import { Box, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import jyloLogo from "../../assets/logo-jylo-combined.png";
import { LogoutOutlined } from "@mui/icons-material";
import { useAuth0 } from "@auth0/auth0-react";

type MainLayoutProps = {
  children: React.ReactNode;
  headerButtons?: React.ReactNode;
  headerLeft?: React.ReactNode;
};

const Mainlayout = ({ children, headerButtons, headerLeft }: MainLayoutProps) => {
  const { logout } = useAuth0();
  const [version, setVersion] = useState<string>("");

  useEffect(() => {
    fetch("/manifest.xml")
      .then((res) => res.text())
      .then((xml) => {
        const match = xml.match(/<Version>([^<]*)<\/Version>/);
        if (match) setVersion(match[1]);
      })
      .catch(() => {});
  }, []);

  return (
    <Stack direction="column" sx={{ height: "100vh", overflow: "hidden" }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        p={2}
        sx={{
          borderBottom: "1px solid",
          borderColor: "divider",
          boxShadow: "0 2px 8px 0 rgba(0,0,0,0.08)",
          zIndex: 1,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              position: "relative",
              "&:hover .version-tooltip": {
                opacity: 1,
                visibility: "visible",
              },
            }}
          >
            <Box
              component="img"
              src={jyloLogo}
              alt="Jylo Office Logo"
              sx={{ height: 24, cursor: "default" }}
            />
            <Typography
              className="version-tooltip"
              variant="caption"
              sx={{
                position: "absolute",
                bottom: "-32px",
                left: "50%",
                transform: "translateX(-50%)",
                backgroundColor: "rgba(0, 0, 0, 0.8)",
                color: "white",
                padding: "4px 8px",
                borderRadius: "4px",
                fontSize: "0.65rem",
                whiteSpace: "nowrap",
                opacity: 0,
                visibility: "hidden",
                transition: "opacity 0.2s, visibility 0.2s",
                zIndex: 1000,
                pointerEvents: "none",
              }}
            >
              {version ? `v${version}` : ""}
            </Typography>
          </Box>
          {headerLeft}
        </Stack>
        <Stack direction={"row"} spacing={2} alignItems={"center"}>
          {headerButtons}
          <IconButton
            title="Log Out"
            color="inherit"
            size="small"
            onClick={() => {
              logout({
                logoutParams: { returnTo: undefined },
                openUrl: false,
              });
            }}
          >
            <LogoutOutlined fontSize="small" />
          </IconButton>
        </Stack>
      </Stack>

      <Box sx={{ flex: 1, overflow: "hidden" }}>{children}</Box>
    </Stack>
  );
};

export default Mainlayout;
